import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Address, CraftyResponse, HQAddress } from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class AddressHttpService {
  readonly http = inject(HttpClient);

  public crafty<T extends 'find' | 'retrieve'>(payload: {
    id?: string;
    operation: T;
    query: string[];
  }): Observable<CraftyResponse<T>> {
    return this.http.post<CraftyResponse<T>>('/crafty', payload);
  }

  public getAddresses(): Observable<Address[]> {
    return this.http.get<Address[]>('/addresses');
  }

  public getAddress(id: number): Observable<Address[]> {
    return this.http.get<Address[]>(`/address/${id}`);
  }

  public createAddress(address: Address): Observable<Address> {
    return this.http.post<Address>('/addresses', address);
  }

  public updateAddress(address: Address, id: number) {
    return this.http.put(`/address/${id}`, address);
  }

  public retrieveHQ() {
    return of({
      address1: 'Railway Arch 275',
      address2: 'Bethwin Road',
      city: 'London',
      latitude: 51.480814,
      longitude: -0.095262,
      postcode: 'SE5 0YW',
      address_id: 'address_id=aPa-1pcBqAoB1w93L15O',
      labels: ['SE5 0YW', 'Railway Arch 275, Bethwin Road, London'],
    });
    // return this.httpClient.get<HQ>(`/hq`);
  }

  public setHQ(payload: HQAddress) {
    return this.http.post<HQAddress>(`/hq`, payload);
  }
}
